module.exports = __webpack_public_path__ + "eda2dceec4f2cd9338572d2b2318a342.svg";